import React, { memo } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { withScreenSize } from '../common/utilities/withScreenSize.jsx';
import { smallMediaQuery } from '../../common/utilities/sizeHelpers';
import { ArrowIcon, arrowDirections } from '../common/utilities/arrowIcon.tsx';
import { ResortConditions } from './resortConditions';

// TECHDEBT: fix hook so we don’t have to disable this rule when we have multiple HOCs
// eslint-disable-next-line react/display-name
export const ResortCardView = withScreenSize(memo(({
    resortHref,
    index,
    resortName,
    baseSnow,
    newSnow,
    reported,
    openStatusFlag,
    openStatus,
    totalLifts,
    openLifts,
    snowCondition,
    contentMgmtBaseUrl,
    forecastIconResourceList,
    forecastIconSize,
    forecastIconSet,
    authId,
    secret,
    stdParameters,
    temperature,
    iconCode,
    feelsLike,
    highTemp,
    lowTemp,
    tempUnitAbbreviation
}) => {

    return (
        <Card>
            <Anchor href={resortHref} >
                <Title>
                    <Badge>{index + 1}</Badge>
                    <Name>
                        {resortName}
                    </Name>
                    <ArrowWrapper>
                        <ArrowIcon strokeColor='#555' arrowDirection={arrowDirections.right} />
                    </ArrowWrapper>
                </Title>
                <ResortConditions
                    temperature={temperature}
                    iconCode={iconCode}
                    forecastIconSet={forecastIconSet}
                    forecastIconSize={forecastIconSize}
                    authId={authId}
                    secret={secret}
                    contentMgmtBaseUrl={contentMgmtBaseUrl}
                    stdParameters={stdParameters}
                    forecastIconResourceList={forecastIconResourceList}
                    baseSnow={baseSnow}
                    newSnow={newSnow}
                    reported={reported}
                    feelsLike={feelsLike}
                    highTemp={highTemp}
                    lowTemp={lowTemp}
                    tempUnitAbbreviation={tempUnitAbbreviation}
                    openStatusFlag={openStatusFlag}
                    openStatus={openStatus}
                    totalLifts={totalLifts}
                    openLifts={openLifts}
                    snowCondition={snowCondition}
                />
            </Anchor>
        </Card>
    );
}));

ResortCardView.displayName = 'ResortCardView';
ResortCardView.propTypes = {
    basePropsData: PropTypes.object
};

const Card = styled.li`
    background-color: white;
    font-weight: 600;
    font-style: normal;
    margin: 5px 0 0 5px;
    width: 49%;
    display: inline-block;
    vertical-align: top;
    border-radius: 2px;

    @media ${smallMediaQuery} {
        width: 100%;
        margin: 6px 0 0 0;
    }
`;

const Anchor = styled.a`
    cursor: pointer;
    text-decoration: none;
`;

const Title = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
    font-size: 16pt;
`;

const Badge = styled.div`
    width: 28px;
    height: 28px;
    background-color: #0083C6;
    color: #ffffff;
    margin: 10px 0 0 10px;
    padding-left: 9px;
    border-radius: 14px;
`;

const Name = styled.h2`
    height: 28px;
    color: #0083C6;
    margin: 10px 0 0 10px;
    font-size: 16pt;
    font-weight: 600;
    font-style: normal;
`;

const ArrowWrapper = styled.div`
    margin: 5px 15px 0 auto;
`;
